import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { ENTITY_LABELS, activityLink, activityTone, changedText } from "../lib/activity";
import { fmtDateTime } from "../lib/format";
import { StatusPill } from "./StatusBadge";

/** Activity rows: who did what, on which item, what changed; each opens its item. */
export default function ActivityList({ rows, compact = false }) {
  const { user } = useAuth();
  return (
    <ul className="divide-y divide-border" data-testid="activity-list">
      {rows.map((row) => {
        const to = activityLink(row, user);
        const changes = changedText(row);
        const body = (
          <>
            <span className={`${activityTone(row.action)} mt-1.5 h-2 w-2 shrink-0 rounded-full`} style={{ background: "var(--tone-ink)" }} aria-hidden="true" />
            <span className="min-w-0 flex-1">
              <span className="block text-sm"><span className="font-medium">{row.user_name || "Utente"}</span> · {row.description}</span>
              {(row.target_label || !compact) && (
                <span className="mt-1 flex flex-wrap items-center gap-2">
                  {ENTITY_LABELS[row.entity] && <StatusPill tone="tone-slate">{ENTITY_LABELS[row.entity]}</StatusPill>}
                  {row.target_label && <span className="min-w-0 truncate text-sm font-medium text-primary">{row.target_label}</span>}
                </span>
              )}
              {changes && <span className="mt-1 block text-xs text-muted-foreground">Modificati: {changes}</span>}
              <span className="mt-0.5 block text-xs text-muted-foreground">{fmtDateTime(row.timestamp)}</span>
            </span>
            {to && <ChevronRight className="mt-1 h-4 w-4 shrink-0 text-muted-foreground" aria-hidden="true" />}
          </>
        );
        return (
          <li key={row.id}>
            {to
              ? <Link to={to} className="flex items-start gap-3 rounded-lg px-2 py-2.5 hover:bg-secondary/60 focus-visible:outline focus-visible:outline-2 focus-visible:outline-ring" data-testid={`activity-${row.id}`}>{body}</Link>
              : <div className="flex items-start gap-3 px-2 py-2.5" data-testid={`activity-${row.id}`}>{body}</div>}
          </li>
        );
      })}
    </ul>
  );
}
